export default __webpack_public_path__ + "static/media/PeggyLovelace.6e588b27.png";